<template>
  <div id="app" class="o-page">
    <my-header class="o-page__header"></my-header>
    <router-view class="o-page__body" :class="[`o-page__body--${color}`]" v-if="$store.state.content.length !== 0"></router-view>
    <div class="o-page__footer" v-if="routeLoaded && $store.state.content.length !== 0">
      <my-contact></my-contact>
      <my-footer></my-footer>
    </div>
    <transition name="quick-fade">
      <my-modal v-if="menuOpen" action="setMenu">
        <my-menu class="o-menu--mobile"></my-menu>
      </my-modal>
      <my-modal v-if="downloadOpen" action="setDownload">
        <my-download></my-download>
      </my-modal>
      <my-modal v-if="videoOpen" action="setVideo">
        <my-video></my-video>
      </my-modal>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MyHeader from '@/components/objects/MyHeader'
import MyContact from '@/components/objects/MyContact'
import MyFooter from '@/components/objects/MyFooter'
import MyModal from '@/components/objects/MyModal'
import MyMenu from '@/components/objects/MyMenu'
import MyDownload from '@/components/objects/MyDownload'
import MyVideo from '@/components/objects/MyVideo'

export default {
  name: 'App',
  components: {
    MyHeader,
    MyContact,
    MyFooter,
    MyModal,
    MyMenu,
    MyDownload,
    MyVideo
  },
  data () {
    return {
      routeLoaded: false,
      color: 'default'
    }
  },
  computed: {
    ...mapState(['menuOpen', 'downloadOpen', 'videoOpen']),
    ...{
      modalOpen () {
        return (this.menuOpen || this.downloadOpen || this.videoOpen)
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.routeLoaded = true
      this.color = to.meta.color
    },
    modalOpen (val) {
      if (val) {
        document.body.classList.add('u-body-lock-scroll')
      } else {
        document.body.classList.remove('u-body-lock-scroll')
      }
    }
  }
}
</script>

<style src="@/assets/styles/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue